var map = {
	"./ic_arbitrum_24.svg": 260,
	"./ic_avalanche_24.svg": 261,
	"./ic_avax_24.svg": 262,
	"./ic_btc.b_24.svg": 263,
	"./ic_btc_24.svg": 264,
	"./ic_busd_24.svg": 265,
	"./ic_dai_24.svg": 266,
	"./ic_eth_24.svg": 267,
	"./ic_frax_24.svg": 268,
	"./ic_glp_24.svg": 269,
	"./ic_gmx_24.svg": 270,
	"./ic_link_24.svg": 271,
	"./ic_mim_24.svg": 272,
	"./ic_settings_24.svg": 273,
	"./ic_tether_24.svg": 274,
	"./ic_uni_24.svg": 275,
	"./ic_usdc.e_24.svg": 276,
	"./ic_usdc_24.svg": 277,
	"./ic_usdt_24.svg": 278,
	"./ic_wallet_24.svg": 279,
	"./ic_wavax_24.svg": 280,
	"./ic_weth_24.svg": 281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 574;